<template>
  <div>
    <gj-alert
        border
        show-icon>
      <!-- <div style="line-height: 20px;">1、点击【去授权】将跳转到亚马逊登录页面，<span style="color: red;">请在授权店铺主账号的常用环境操作，以免关联</span></div>
      <div style="line-height: 20px;">2、授权前请将后台页面切换到对应的站点</div> -->
      <div style="line-height: 20px;">1、在安全环境授权成功后，请复制验证码回到系統，输λ验证码进行验证；验证通过后即授权成功</div>
      <div style="line-height: 20px;">2、亚马逊官方支持北美、欧洲、日本、澳洲、印度及阿联酋站</div>
      <div style="line-height: 20px;">3、授权成功后，系统将会：</div>
      <ul class="auth-tip--ul" style="margin: 0">
        <li class="auth-tip--li">获取您的广告数据</li>
        <li class="auth-tip--li">支持您在系统进行广告活动数据操作</li>
        <li class="auth-tip--li">亚马逊广告相关业绩数据的访问权限</li>
      </ul>
    </gj-alert>

    <el-form ref="form" :model="ruleForm" :rules="rules" style="margin: 20px 0;" label-width="150px" class="form">

      <el-form-item label="店铺名称">
        <gj-input v-model="form.marketName" width="400px" disabled></gj-input>
      </el-form-item>

      <el-form-item label="账号类型">
        <gj-select v-model="accountType" :options="accountTypeOption" :filterable="false" :clearable="false" width="400px"></gj-select>
      </el-form-item>

      <el-form-item label="区域" style="margin-bottom: 0;">
        <gj-select v-model="form.areaId" :options="areaOption" disabled width="400px"></gj-select>
      </el-form-item>

      <el-form-item :show-message="false" class="country-checkbox">
        <el-checkbox-group v-model="form.marketIds" style="width: 400px" :disabled="loading">
          <template v-if="form.areaId==='na'||form.areaId==='eu'">
            <template v-for="(item, index) in marketItem.items">
              <el-checkbox :key="index" :label="item.id" :disabled="adsSupplyCountryCode.indexOf(item.countryCode)<0">
                {{ countryMap[item.countryCode] ? countryMap[item.countryCode].text : '-' }}
              </el-checkbox>
            </template>
          </template>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="授权链接" style="margin-top: 5px;">
        <gj-input v-model="url" width="312px" placeholder="请稍等或选择国家" disabled></gj-input>
        <gj-button style="margin-left: 8px;" v-copy="url" :loading="cantGetUrl">{{cantGetUrl?'生成中':'复制链接'}}</gj-button>
      </el-form-item>

      <el-form-item label="验证码" prop="code">
        <gj-input v-model="ruleForm.code" width="312px" placeholder="请输入" :disabled="loading"></gj-input>
        <gj-button style="width: 80px;margin-left: 8px;" @click="verification('form')" :disabled="!ruleForm.code" :loading="loading">验证</gj-button>
      </el-form-item>

      <div class="status-box">
        <div :class="{'status-success':pass==='success','status-fail':pass==='fail'}">{{ completeMsg }}</div>
      </div>

    </el-form>

  </div>
</template>

<script>
import {MarketEnum} from "../enum";
import {transformToMap} from "@/utils/common";
import {getAdsAuthUrl, getAdsSupplyCountryCode} from "@/api/system";
import {
  // 获取验证地址
  getAdsBatchAuthUrl,
  // 验证广告授权
  adsBatchAuthCheck,
  // 保存广告授权
  adsBatchAuthSave,
  myCancel
} from "@/api/system";
import {amazonCountryOption} from "@/utils/options";

export default {
  name: "ad-authorization",
  data() {
    return {
      pass: 'none',
      completeMsg:'',

      cantGetUrl:false,

      loading:false,

      successMarketIds:'',

      areaOption: MarketEnum.areaOption,
      countryOption: [],
      ruleForm: {
        code: ''
      },
      url: '',
      rules: {
        code: [{required: true, message: '请输入验证码', trigger: ['blur', 'change']}]
      },
      accountType:'seller',
      accountTypeOption:[
        {text:'卖家账号',id:'seller'},
        {text:'供应商账号',id:'vendor'},
        {text:'代理账号',id:'agency'},
      ],
      countryMap: transformToMap(amazonCountryOption),
    }
  },
  props: {
    adsSupplyCountryCode:{
      type:Array,
      default: function (){
        return []
      }
    },
    marketItem: {
      required: true
    },
    form: {
      type: Object,
      default: function () {
        return {
          marketName: null,
          areaId: 'na',
          countryCodes: [],
          unionAccount: true,
          marketIds:[]
        }
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    // marketItem:{
    //   handler: function (n, o) {
    //     this.getUrl();
    //   }
    // },
    'form.marketIds': {
      handler: function (n, o) {
        this.getUrl();
        this.ruleForm.code = '';
        this.pass = 'none';
        this.$emit('passChange', this.pass);
      },
      immediate:true
    }
  },
  methods: {
    getUrl() {
      if(this.form.marketIds.length===0){
        this.url = '';
        if (typeof myCancel === 'function') {
          // 取消请求
          myCancel()
        }
        this.cantGetUrl=false;
        return
      }
      this.cantGetUrl=true;
      let param = {
        marketId: this.form.marketIds.map(r => {
          return r
          // if(r.marketId){
          //   return r.marketId
          // }else {
          //   return r.id
          // }
        })
      };
      getAdsBatchAuthUrl(param).then((authUrl) => {
        this.url = authUrl;
        this.cantGetUrl=false;
      })
    },
    verification(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading=true;
          let param={
            marketId:this.form.marketIds,//站点id数组
            adsCode:this.ruleForm.code,//授权校验码
            profileType:this.accountType,//广告授权账号类型，默认seller(seller:卖家, vendor:供应商, agency:代理)
            sellerId:this.marketItem.sellerId//店铺编码
          }
          adsBatchAuthCheck(param).then(data=>{
            if (data.authFlag) {
              this.pass = 'success';
              this.successMarketIds = data.successMarketIds;
              this.completeMsg = data.authMsg;
            } else {
              this.completeMsg = data.authMsg;
              this.pass = 'fail';
            }
            // this.pass = 'success';
            // this.pass = 'fail';
            this.$emit('passChange', this.pass);
            this.$emit('adPassed')
          }).complete(()=>{this.loading = false;})
        } else {
          return false;
        }
      });
    },
    saveAD(fn){
      let param={
        successMarketIds:this.successMarketIds//授权成功的站点id集合
      }
      adsBatchAuthSave(param).then(data=>{
        if(fn){
          fn();
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.status-box {
  padding-left: 150px;
  height: 20px;
}
</style>